<!-- 
    FORM PARA INCLUSAO DE NOVO LEAD
-->

<script>
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import { SysVars } from '../main';
import InputColor from '../components/input-color'
import Vue from 'vue';
import CrmTagForm from './crm-tag-form'
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        index: '',
        crud: '',
        params: {},
    },
    
    components: {
        InputColor, CrmTagForm
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            showTagForm: false,
            codtag: null,
            crudTag: '',

            leadcrm: {
                codlead: null,
                nome: null,
                data: null,
                codusuario: null,
                codorg: null,
                codtag: null,
                visivel: null,
            },

            telefones: [],
            emails: [],

            organizacao: {
                novo: false,
                nome: null,
                codorg: null,
            },

            inputOrg: {
                url: '/crm/find/organizacao?nome=',
                permite_novo: true,
                codigo: null,
                // label: 'Organização',
                icon: 'fa-university', 
                // placeholder: 'Nome da Organização',
            },

            inputNome: {
                url: '/crm/find/pessoa?nome=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.leadcrm.codorg.label,
                icon: 'fa-user', 
                // placeholder: 'Nome do Contato',
            },            

            inputFone: {
                url: '/crm/find/pessoa?fone=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.fonecrm.numero.label,
            },           

            inputEmail: {
                url: '/crm/find/pessoa?email=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.emailcrm.email.label,
            },           

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        administrador: function () {
            return SysVars.usuarioAdministrador
        },
    },

    methods: {
        handleCadastroOrigem () {
            this.$router.push('/crm/config')
        },

        handleSalvar () {
            var valido = true;

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else if (valido) {
                    // if (this.organizacao.novo)
                        // this.leadcrm.dados = { org: this.organizacao }
                    // this.leadcrm.telefones = this.telefones
                    // this.leadcrm.emails = this.emails
                    this.apiLead(this.leadcrm, this.leadcrm.codlead, this.callBackPost)
                }
            })

        },

        handleAdicionarTag () {
            this.codtag = null
            this.crudTag = SysVars.crudI
            this.showTagForm = true
        },

        handleEditarTag (cod) {
            this.crudTag = SysVars.crudU
            this.codtag = cod
            this.showTagForm = true
        },

        handleCloseTag (tag) {
            this.$refs.etiqueta.loadData()
            if (tag)
               this.leadcrm.codtag = tag.codtag
            this.showTagForm = false
        },

        callBackPost (pessoa) {
            this.closeForm(pessoa)
        },

        closeForm (pessoa) {
            this.$emit('closeform', pessoa)
        },

        handleNovoOrg (text) {
            if (!this.organizacao)
              this.organizacao = {}
            this.organizacao.novo = true
            this.organizacao.nome = text
        },

        handleSelectOrg (selected) {
            this.organizacao = selected
            if (this.organizacao) {
                this.organizacao.novo = false
            }
        },

        handleIncluirOrg (selected) {
            this.leadcrm.codorg = selected.codigo
            this.organizacao.novo = false
        },

        async loadData () {
            await this.$store.dispatch('loadLead', { id: this.index } )
            if (this.$store.getters.getLeadCrm) {
                this.leadcrm = {...this.$store.getters.getLeadCrm}
                this.setFields()
            }
        },

        setFields () {
            // if (this.leadcrm.codorg && this.$refs.organizacao) {
            //     this.organizacao = this.leadcrm.organizacao[0]
            //     this.organizacao.novo = false
            //     this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao)
            // }
        },

    },

    watch: {
    },

    mounted () {
        this.$nextTick(function () {
            if (this.$refs.titulo) {
               this.$refs.titulo.focus()
            }
        })

    },

    created () {
        if (this.index) 
          this.loadData()
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; max-width: 100%">
            <div class="nb-modal-header">
                <h4 class="def-title" v-if="leadcrm.codlead">Alterar Lead</h4>
                <h4 class="def-title" v-else>Novo Lead</h4>
            </div>
            <div class="nb-modal-scrollable-body">

                <div class="row">
                    <form-field ref="titulo" v-model="leadcrm.titulo" type="text" col="12" :metadata="metadata.leadcrm.titulo"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="leadcrm.pessoanome" type="text" col="12" :metadata="metadata.leadcrm.pessoanome"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="leadcrm.orgnome" type="text" col="12" :metadata="metadata.leadcrm.orgnome"></form-field>
                </div>
                <div class="row">
                    <div class="col-md-12 col-12">  
                        <input-color ref="etiqueta" v-model="leadcrm.codtag" :params="{ edit: true, label: 'Etiqueta', url: 'crm/tag/list/negocio' }" @editar="handleEditarTag" @adicionar="handleAdicionarTag"></input-color>
                    </div>
                </div>
                <div class="row">
                    <form-field v-model="leadcrm.fonenumero" type="fone" col="4" :metadata="metadata.leadcrm.fonenumero"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="leadcrm.email" type="email" col="12" :metadata="metadata.leadcrm.email"></form-field>
                </div>
                <!-- <div class="row">
                    <form-field v-model="leadcrm.codusuario" type="select2" col="6" :metadata="metadata.leadcrm.codusuario"
                        ref="usuario" name="codusuario" :v-errors="errors" v-validate="metadata.leadcrm.codusuario.validator"></form-field>
                </div> -->
                <div class="row">
                    <form-field v-model="leadcrm.valor" type="value" col="4" :metadata="metadata.leadcrm.valor" preaddon="R$"
                        name="valor" :v-errors="errors" v-validate="metadata.leadcrm.valor.validator"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="leadcrm.codorigem" type="select2" col="12" 
                        :metadata="metadata.leadcrm.codorigem">
                        <a v-if="administrador" style="cursor: pointer; color: #0091ea;" @click="handleCadastroOrigem">Acesso ao cadastro de origem</a>
                    </form-field>
                </div>
            </div>
            <div class="modal-footer">
                <v-button label="Cancelar" class="float-right" icon="fa-arrow-left" @click="closeForm"></v-button>
                <v-button label="Salvar" class="float-right" :nb-btdef="true" @click="handleSalvar"></v-button>
            </div>
        </div>
        <crm-tag-form v-if="showTagForm" @closeform="handleCloseTag" tptag="N" :index="codtag" :crud="crudTag" ></crm-tag-form>

    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-lead-novo-form.vue